"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShortenedText = exports.getShortenedTitle = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2020 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var BubbleHoverTrigger_1 = require("../Bubble/BubbleHoverTrigger");
var Bubble_1 = require("../Bubble/Bubble");
// ShortenText adds ellipsis (…) in the middle of the string.
// SIDE_SCALE_RATIO is a constant which tells the percentage of
// of the string characters to be taken from both sides to produce
// final shortened string
var SIDE_SCALE_RATIO = 0.42;
function getElementWidth(element) {
    return Math.ceil(element.getBoundingClientRect().width);
}
function getShortenedTitle(title, element) {
    var elementWidth = getElementWidth(element);
    var scrollWidth = element.scrollWidth;
    if (elementWidth >= scrollWidth) {
        return title;
    }
    var titleLength = title.length;
    var numChars = titleLength * (elementWidth / scrollWidth);
    var numCharsSideStrip = Math.floor(numChars * SIDE_SCALE_RATIO);
    var pre = title.substr(0, numCharsSideStrip);
    var post = title.substr(titleLength - numCharsSideStrip, titleLength);
    return pre + "\u2026" + post;
}
exports.getShortenedTitle = getShortenedTitle;
/**
 * @internal
 */
var ShortenedText = /** @class */ (function (_super) {
    tslib_1.__extends(ShortenedText, _super);
    function ShortenedText(props) {
        var _this = _super.call(this, props) || this;
        _this.textRef = react_1.default.createRef();
        _this.state = {
            title: props.children,
            customTitle: false,
        };
        return _this;
    }
    ShortenedText.prototype.componentDidMount = function () {
        this.checkTitle();
    };
    ShortenedText.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        if (this.props.children !== nextProps.children) {
            this.setState({
                title: nextProps.children,
                customTitle: false,
            });
        }
    };
    ShortenedText.prototype.componentDidUpdate = function () {
        if (this.state.customTitle) {
            return;
        }
        this.checkTitle();
    };
    ShortenedText.prototype.checkTitle = function () {
        var element = this.props.getElement(this);
        var title = this.props.children;
        var elementWidth = getElementWidth(element);
        if (elementWidth > 0 && elementWidth < element.scrollWidth) {
            this.setState({ title: getShortenedTitle(title, element), customTitle: true });
        }
    };
    ShortenedText.prototype.recomputeShortening = function () {
        // causes repaint & checkTitle to be called
        this.setState({
            title: this.props.children,
            customTitle: false,
        });
    };
    ShortenedText.prototype.renderTextWithBubble = function () {
        return (react_1.default.createElement(BubbleHoverTrigger_1.BubbleHoverTrigger, { showDelay: 0, hideDelay: 0, eventsOnBubble: this.props.tooltipVisibleOnMouseOver },
            react_1.default.createElement(Bubble_1.Bubble, { alignPoints: this.props.tooltipAlignPoints }, this.state.customTitle ? this.props.children : ""),
            this.renderText()));
    };
    ShortenedText.prototype.renderText = function () {
        var TagName = this.props.tagName;
        return (react_1.default.createElement(TagName, { ref: this.textRef, className: classnames_1.default(this.props.className, "shortened", {
                "is-shortened": this.state.customTitle,
                "is-whole": !this.state.customTitle,
            }) }, this.state.title));
    };
    ShortenedText.prototype.render = function () {
        if (this.state.customTitle && this.props.displayTooltip) {
            return this.renderTextWithBubble();
        }
        return this.renderText();
    };
    ShortenedText.defaultProps = {
        className: "",
        tagName: "span",
        tooltipAlignPoints: [{ align: "cr cl" }],
        tooltipVisibleOnMouseOver: false,
        getElement: function (context) {
            // Necessary for testing width in JSDOM env.
            return context.textRef.current;
        },
        displayTooltip: true,
    };
    return ShortenedText;
}(react_1.PureComponent));
exports.ShortenedText = ShortenedText;
//# sourceMappingURL=ShortenedText.js.map